import type { Filter } from "@1js/pl-card-components";
import {
  PromptFiltersMobileV2,
  PromptFiltersV2,
} from "@1js/pl-card-components";
import * as React from "react";
import { useIsSmallScreen } from "../../hooks/useIsSmallScreen";

type Props = {
  filters: Filter[];
  selectedFilters: Record<string, string[]>;
  isLoading?: boolean;
  onFilterChanged: (
    selectedValues: Record<string, string[]>,
    filters: Filter[]
  ) => void;
  onOpenChanged: (isOpen: boolean, filters: Filter[]) => void;
  onCleared: () => void;
};

export const FiltersV2: React.FC<Props> = React.memo(
  ({
    filters,
    selectedFilters,
    isLoading,
    onFilterChanged,
    onOpenChanged,
    onCleared,
  }) => {
    const isMobile = useIsSmallScreen();
    return (
      <>
        {!isMobile && (
          <PromptFiltersV2
            appearance="web"
            tab="all"
            filters={filters}
            selectedFilters={selectedFilters}
            isLoading={isLoading}
            onFilterChanged={onFilterChanged}
            onOpenChanged={onOpenChanged}
          />
        )}
        {isMobile && (
          <PromptFiltersMobileV2
            filters={filters}
            selectedFilters={selectedFilters}
            onApplyFiltered={onFilterChanged}
            isLoading={isLoading}
            onOpenChanged={onOpenChanged}
            onCleared={onCleared}
          />
        )}
      </>
    );
  }
);
FiltersV2.displayName = "AllPromptsFilters";
